import React from 'react'
import img201 from './images/About.jpg'
import img203 from './images/prince12.png'


function abouts() {
    return (
        <>
            <div className="container mr-5 p-3 ">
                <div className="row ">
                    <div className="col-sm ">

                        <h2 className='bg-info p-2'>About E-SELLER Support </h2>
                        <p> At E Seller Support, we are more than just providing services; we are a dedicated partner in your eCommerce success, offering top-notch Ecommerce Solution. With our in-depth expertise and proven track record, we offer customized Ecommerce Solution that meets your unique business needs, ensuring smooth operations and maximum productivity on Amazon and Flipkart. </p>

                        <p> Our comprehensive services, from account management to custom product development, are designed to maximize your marketing potential and increase your brand presence. Count on E Seller Support to provide the strategic guidance, innovative solutions, and unwavering support necessary to thrive in a competitive Ecommerce environment. Choose us for our unmatched expertise, personalized service, and dedication to moving your business forward with the best Ecommerce Solution available.</p>
                    </div>
                    <div className="col-sm text-center">
                        <img src={img201} alt='Queryimg' />
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="sectionfour-intro wow shake animated">
                    <div className="border-title text-center bg-secondary">
                        <h2>Innovative, Impactful and <span className="pulse1">Responsive</span></h2>
                        <p className="small-desc" color='#2b2b2b'>We also provide all services related to e-commerce marketing, digital marketing and web development to boost your brand's online presence.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm">
                        <h3>Our Vision</h3>
                        <p><ul>
                            <li>To leverage our deep expertise and understanding of the business domain and creating solutions for our clients' business needs. </li>
                            <li>To help clients with brand building and creating a positive and a strong relationship with their audience. </li>
                            <li>To be known for our unique approaches and quality work towards providing the highest satisfaction to our clients.</li>
                        </ul></p>
                    </div>
                    <div className="col-sm">
                        <h3>Our Values</h3>
                        <p><ul>
                            <li>Deliver excellent services to our clients.  </li>
                            <li>Transparency and commitment towards work and getting the job done in the best possible way.</li>
                        </ul></p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm">
                        <h3>Our Mission</h3>
                        <p><ul>
                            <li>To constantly upgrade our technology and competencies. </li>
                            <li>To maintain a decent relationship with our clients and provide services to expand their reach to new markets. </li>
                            <li>Provide impeccable customer service with the highest level of expertise.</li>
                        </ul></p>
                    </div>
                    <div className="col-sm">
                        <h3>Prompt Support</h3>
                        <p><ul>
                            <li>Our adept, zealous, and knowledgeable team of professionals is at your service. We strive to resolve our client's concerns within two business days.</li>
                        </ul></p>
                    </div>
                </div>
            </div>
            <div className="container ">
                <div className="section-header section-header--small">
                    <div className="border-title text-center">
                        <h2 className='bg-dark  text-light p-3'>Our <span className="pulse1">  Director</span></h2>
                    </div>
                </div>
                <img src={img203} alt='director' />

            </div>


        </>

    )
}

export default abouts
